/**
 * @generated SignedSource<<ececbca6039026f0ddb64ace6fa88579>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type useDeleteMutation$variables = {
  id: string;
};
export type useDeleteMutation$data = {
  readonly deleteNode: string | null;
};
export type useDeleteMutation = {
  response: useDeleteMutation$data;
  variables: useDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ScalarField",
    "name": "deleteNode",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "89d15055d2e1d91677fb8de077a21db8",
    "id": null,
    "metadata": {},
    "name": "useDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation useDeleteMutation(\n  $id: ID!\n) {\n  deleteNode(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "063c954cf4c228aa37e9a29862a95fc6";

export default node;
